"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id", "method", "action"];
const _hoisted_2 = {
    ref: "modal-ref",
    class: "modal fade show",
    "aria-hidden": "true"
};
const _hoisted_3 = { class: "modal-dialog modal-lg position-center" };
const _hoisted_4 = ["innerHTML"];
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ModalCreate',
    props: {
        url: {},
        query: {},
        method: {},
        action: {},
        formId: {}
    },
    setup(__props) {
        const props = __props;
        const elm = (0, vue_3.useTemplateRef)('modal-ref');
        const modal = (0, vue_3.ref)();
        function openDialog() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const html = yield fetch(props.url + ((_a = props.query) !== null && _a !== void 0 ? _a : ''), {
                    method: 'POST',
                    headers: {
                        accept: 'application/json, text/javascript, */*; q=0.01',
                        'X-CSRF-TOKEN': (_c = (_b = document.querySelector('meta[name="csrf-token"]')) === null || _b === void 0 ? void 0 : _b.getAttribute('content')) !== null && _c !== void 0 ? _c : '',
                    },
                }).then((r) => r.text());
                modal.value = html;
                yield (0, vue_3.nextTick)();
                window.initialize();
                if (elm.value)
                    window._modal.show(elm.value);
            });
        }
        return (_ctx, _cache) => {
            var _a;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", {
                    onClick: openDialog,
                    style: { "display": "contents" }
                }, [
                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                ]),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createElementVNode)("form", {
                        id: props.formId + '-form',
                        method: (_a = props.method) !== null && _a !== void 0 ? _a : 'POST',
                        action: props.action,
                        onSubmit: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(() => { }, ["prevent"]))
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("div", {
                                    class: "modal-content",
                                    innerHTML: modal.value
                                }, null, 8, _hoisted_4)
                            ])
                        ], 512)
                    ], 40, _hoisted_1)
                ]))
            ], 64));
        };
    }
});
